import React, { Component } from "react";

import Select from "../Select";

import "./_style.scss";

const defaultCountries = window.Chuffed && window.Chuffed.supportedCountries || [];
const defaultCategories = window.Chuffed && window.Chuffed.supportedCategories || [];

class DiscoverFilters extends Component {
  render() {
    const {
      onCategorySelect,
      onCategorySelectAll,
      onCategoryDeselect,
      onCategoryClose,
      onCountrySelect,
      onCountrySelectAll,
      onCountryDeselect,
      onCountryClose,
      selectedCategories,
      selectedCountries,
      selectedOrderBy,
      onOrderBySelect,
      onOrderBySelectAll,
    } = this.props;

    return (
      <div className="discover-filters">
        <div className="discover-filters__filters" ref="filters">
          <div className="discover-filters__filter">
            <span className="discover-filters__showMe discover-filters__text">
              Show me
            </span>
            <Select
              className="discover-filters__filter-select"
              name="categories"
              items={defaultCategories}
              showAllItem={{ label: "All", value: "all" }}
              onItemSelect={onCategorySelect}
              onItemDeselect={onCategoryDeselect}
              onSelectAll={onCategorySelectAll}
              selectedItems={selectedCategories}
              onClose={onCategoryClose}
              overlayContainer={() => this.refs.filters}
              allowMultiSelect
            />
          </div>
          <div className="discover-filters__filter">
            <span className="discover-filters__campaignsFrom discover-filters__text">
              campaigns
              {
                !!selectedCountries.length
                  && (
                  <span>
                    {" "}
                    {" "}
                    from
                  </span>
                  )
              }
            </span>
            <Select
              className="discover-filters__filter-select"
              name="countries"
              items={defaultCountries}
              showAllItem={{ label: "Worldwide", value: "worldwide" }}
              onItemSelect={onCountrySelect}
              onItemDeselect={onCountryDeselect}
              onSelectAll={onCountrySelectAll}
              selectedItems={selectedCountries}
              onClose={onCountryClose}
              overlayContainer={() => this.refs.filters}
              allowMultiSelect
            />
          </div>

          <div className="discover-filters__filter">
            <span className="discover-filters__order discover-filters__text">
              sorted by
            </span>
            <Select
              className="discover-filters__filter-select"
              name="orderBy"
              onItemSelect={onOrderBySelect}
              selectedItems={selectedOrderBy}
              showAllItem={{ label: "Trending", value: "trending" }}
              onSelectAll={onOrderBySelectAll}
              items={[
                { label: "Most raised", value: "most_raised" },
                { label: "Newest", value: "newest" },
              ]}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default DiscoverFilters;
